import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcSeccionSeguimiento,
    EnumIdsTcTipoPuntoInspeccion,
    EnumIdsTwTcDecisionInspeccion,
    EnumIdsTwTcTipoClonacion,
} from '../../../_importacion/solicitudes/types/enum';
import { MatriculaPrecintoPopupComponent } from '../components/popup/matriculaprecinto/matriculaPrecintoPopup.component';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { SolicitudProductosExViewModel } from '../productos/productosEx.types';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { InspeccionesExService } from './inspeccionesEx.service';
import { TInspeccionExViewModel, TwSolicitudFrExViewModel, TTratamientoDesinfeccionExViewModel } from './inspeccionesEx.types';
import { TComentarioInspectorExViewModel } from '../seguimiento/seguimientoEx.types';
import { SeguimientoExService } from '../seguimiento/seguimientoEx.service';

@Component({
    selector: 'app-inspeccionesex',
    templateUrl: './inspeccionesEx.component.html',
    styleUrls: ['./inspeccionesEx.component.scss'],
})
export class InspeccionesExComponent extends ComponentBase implements OnInit {
    @ViewChild(MatriculaPrecintoPopupComponent)
    private matriculaPrecintoPopupComponent: MatriculaPrecintoPopupComponent;

    inspeccionEx: TInspeccionExViewModel;
    solicitudEquipamientosEx: SolicitudProductosExViewModel;
    habilitarGuardar = false;
    habilitarEdicion = false;
    habilitarNuevoSeguimiento = false;
    //Boton seguimiento Pcf
    habilitarReasignacionPcf = false;
    IdSolicitudEx: number;
    IdInspector: number;
    IdTipoSolicitudEx: number;
    IdEstadoSolicitudEx: number;
    labelDocumental = '';
    labelIdentidad = '';
    labelFisica = '';
    labelApto = 'APTO';
    labelNoApto = 'NO APTO';
    habilitarAceptarDecision = false;
    habilitarRechazarDecision = false;
    editMode = false;
    matriculasInsp: any[];
    EsAeropuerto: boolean;
    Documental: boolean | null = null;
    Identidad: boolean | null = null;
    Fisica: boolean | null = null;
    SeEfectuaIdentidadFisica = false;
    tituloTipoSolicitudEx: string;
    tituloEstadoSolicitudEx: string;
    IdEstadoCertificadoFitoEx: number;
    tituloEstadoCertificadoFitoEx: string;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;
    codigoTipoSolicitud: string;
    CodigoSolicitud: string;
    visibilitySpinner = false;
    esClonada = false;
    inspeccionReexportacion = false;
    firstInit = true; //para subscribirse al selectedEmitter solo la 1ª vez
    fechaFinalizacion: string | null = null;
    requerirObservaciones: boolean | null = false;
    colsObservaciones: any[];
    TComentarioInspectorExCollection: TComentarioInspectorExViewModel[];
    //RDLF:25/10/24 eliminar estas validaciones (tarea 144306)
    //requerirIdentidad: boolean | null = false;
    //requerirFisica: boolean | null = false;
    visibilityDecision = false;
    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    //FR
    mostrarFrecuenciaReducida = false;
    colsFrecRed: any[];
    frInsp: TwSolicitudFrExViewModel[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private inspeccionesExService: InspeccionesExService,
        private navMenuService: NavMenuService,
        private globalService: GlobalService,
        private solicitudExService: SolicitudExService,
        private seguimientoExService: SeguimientoExService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.inspeccionEx = new TInspeccionExViewModel();
    }

    ngOnInit() {
        this.colsFrecRed = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdSolicitudEx', header: 'IdSolicitud', display: 'none' },
            { field: 'GrupoFrDescripcion', header: 'Grupo FR' },
            { field: 'Frecuencia', header: '% Frecuencia' },
            { field: 'PorcentajePif', header: '% PIF' },
            { field: 'PorcentajeNacional', header: '% Nacional' },
        ];

        this.colsObservaciones = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Observaciones', header: 'Descripción' },
            { field: 'Inspector', header: 'Inspector' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdSeccionDescripcion', header: 'Seccion' },
            { field: 'IdMotivoDescripcion', header: 'Motivo' },
        ];

        let idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.IdSolicitudEx = idSolicitudEx;

        this.IdInspector = this.loggedInUser!.Id;

        this.guardRefreshPage(idSolicitudEx);

        this.createForm();

        //Siempre tendrá un idSolicitudEx
        if (idSolicitudEx) {
            this.loading = true;

            //Cargamos FR
            this.inspeccionesExService.getFr(idSolicitudEx).subscribe(result => {
                //FR
                this.mostrarFrecuenciaReducida = result != null && result.length > 0 && this.isInspector; //El solicitante ahora no lo ve (RDLF: 21/12/2020)

                if (this.mostrarFrecuenciaReducida) {
                    this.frInsp = result;
                }
            });

            this.onSelectedIdentidadFisica();

            //recuperar la inspeccion
            this.inspeccionesExService.getInspeccionEx(idSolicitudEx).subscribe(result => {
                //HAY INSPECCIÓN
                if (result) {
                    this.inspeccionEx = result;

                    this.editMode = true;

                    this.IdTipoSolicitudEx = this.inspeccionEx.IdTipoSolicitudEx;
                    this.IdEstadoSolicitudEx = this.inspeccionEx.IdEstadoSolicitudEx;
                    this.IdEstadoCertificadoFitoEx = this.inspeccionEx.IdEstadoCertificadoFitoEx;
                    this.EsAeropuerto = this.inspeccionEx.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO ? true : false;
                    this.tituloTipoSolicitudEx = this.inspeccionEx.IdTipoSolicitudExDescripcion;
                    this.IdResultadoEnvioMuestrasLaboratorioEx = this.inspeccionEx.IdResultadoEnvioMuestrasLaboratorioEx;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.inspeccionEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                    this.IdSubTipoSolicitudEx = this.inspeccionEx.IdSubTipoSolicitudEx;
                    this.IdSubTipoSolicitudExDescripcion = this.inspeccionEx.IdSubTipoSolicitudExDescripcion;
                    this.esClonada =
                        this.inspeccionEx.TwSolicitudJerarquiaEx != null &&
                        this.inspeccionEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.fechaFinalizacion = this.datepipe.transform(result.FechaFinalizacion, 'dd/MM/yyyy HH:mm:ss');

                    //SI ES PREVIA
                    if (this.inspeccionEx.EsPrevia) {
                        if (
                            this.inspeccionEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.inspeccionEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitudEx += '-Previa';
                        }
                    }
                    this.codigoTipoSolicitud = this.inspeccionEx.CodigoTipoSolicitud;
                    this.tituloEstadoSolicitudEx = this.inspeccionEx.IdEstadoSolicitudExDescripcion;
                    this.tituloEstadoCertificadoFitoEx = this.inspeccionEx.IdEstadoCertificadoFitoExDescripcion;
                    this.CodigoSolicitud = this.inspeccionEx.CodigoSolicitud;

                    this.loading = false;

                    this.habilitarGuardar = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.GUARDAR_INSPECCION_EXPORTACION,
                        this.IdEstadoSolicitudEx,
                    ).Visible;

                    this.habilitarEdicion = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_INSPECCIONES_EXPORTACION,
                        this.IdEstadoSolicitudEx,
                    ).Editable;

                    this.habilitarNuevoSeguimiento = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                        this.inspeccionEx.IdEstadoSolicitudEx,
                    ).Editable;

                    this.verificarReasignacionPcf(this.isInspector);

                    this.habilitarReasignacionPcf =
                        this.habilitarReasignacionPcf &&
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION, this.IdEstadoSolicitudEx).Editable;

                    if (this.isSolicitante) {
                        this.TComentarioInspectorExCollection = this.inspeccionEx.TComentarioInspectorExCollection.filter(
                            t => t.VisibleSolicitante && t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
                        );
                    } else {
                        this.TComentarioInspectorExCollection = this.inspeccionEx.TComentarioInspectorExCollection.filter(
                            t => t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
                        );
                    }

                    this.matriculasInsp = this.inspeccionEx.TSolicitudEquipamientoExCollection;

                    this.matriculasInsp.map((o, i) => {
                        const control = new UntypedFormControl(o.Inspeccion); // if first item set to true, else false
                        (this.form.controls.matriculasInsp as UntypedFormArray).push(control);
                    });

                    this.updateForm();

                    this.gestionarVisibilidadDecision();

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.DisableControlsConsulta();
                    }

                    // @author: scalero1 - No debería ser nunca nulo TReexportacionEx, en éste punto.
                    if (
                        this.inspeccionEx.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION &&
                        this.isInspector &&
                        this.inspeccionEx.TReexportacionEx == null
                    ) {
                        this.addWarningMessage('Es necesario cumplimentar previamente los datos del apartado de Re-Exportación');
                        for (let control in this.form.controls) {
                            this.form.controls[control].disable();
                        }
                        this.habilitarGuardar = false;
                        this.habilitarEdicion = false;

                        return;
                    }
                }
                //NO HAY INSPECCIÓN
                else {
                    this.editMode = false;

                    //cargo los equipamientos
                    this.inspeccionesExService.getEquipamientosEx(idSolicitudEx).subscribe(result => {
                        this.solicitudEquipamientosEx = result;

                        this.IdTipoSolicitudEx = this.solicitudEquipamientosEx.IdTipoSolicitudEx;
                        this.IdEstadoSolicitudEx = this.solicitudEquipamientosEx.IdEstadoSolicitudEx;
                        this.IdEstadoCertificadoFitoEx = this.solicitudEquipamientosEx.IdEstadoCertificadoFitoEx;
                        this.EsAeropuerto =
                            this.solicitudEquipamientosEx.TPuntoInspeccion.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO ? true : false;
                        this.tituloTipoSolicitudEx = this.solicitudEquipamientosEx.TcTipoSolicitudEx.Descripcion;
                        this.IdResultadoEnvioMuestrasLaboratorioEx = this.solicitudEquipamientosEx.IdResultadoEnvioMuestrasLaboratorioEx;
                        this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.solicitudEquipamientosEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                        this.IdSubTipoSolicitudEx = this.solicitudEquipamientosEx.IdSubTipoSolicitudEx;
                        this.IdSubTipoSolicitudExDescripcion = this.solicitudEquipamientosEx.IdSubTipoSolicitudExDescripcion;
                        this.esClonada =
                            this.solicitudEquipamientosEx.TwSolicitudJerarquiaEx != null &&
                            this.solicitudEquipamientosEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                                ? true
                                : false;

                        //SI ES PREVIA
                        if (this.solicitudEquipamientosEx.EsPrevia) {
                            if (
                                this.solicitudEquipamientosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                                this.solicitudEquipamientosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                            ) {
                                this.tituloTipoSolicitudEx += '-Previa';
                            }
                        }
                        this.codigoTipoSolicitud = this.solicitudEquipamientosEx.TcTipoSolicitudEx.Codigo;
                        this.tituloEstadoSolicitudEx = this.solicitudEquipamientosEx.TcEstadoSolicitudEx.Descripcion;
                        this.tituloEstadoCertificadoFitoEx = this.solicitudEquipamientosEx.TwTcEstadoCertificadoFitoEx.Descripcion;
                        this.CodigoSolicitud = this.solicitudEquipamientosEx.CodigoSolicitud;

                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_INSPECCION_EXPORTACION,
                            this.IdEstadoSolicitudEx,
                        ).Visible;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_INSPECCIONES_EXPORTACION,
                            this.IdEstadoSolicitudEx,
                        ).Editable;

                        this.habilitarNuevoSeguimiento = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                            this.solicitudEquipamientosEx.IdEstadoSolicitudEx,
                        ).Editable;

                        this.verificarReasignacionPcf(this.isInspector);

                        this.habilitarReasignacionPcf =
                            this.habilitarReasignacionPcf &&
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION, this.IdEstadoSolicitudEx).Editable;

                        if (!this.habilitarEdicion) {
                            //metodo para deshabilitar los controles
                            this.DisableControlsConsulta();
                        }

                        if (this.isSolicitante) {
                            this.TComentarioInspectorExCollection = this.solicitudEquipamientosEx.TComentarioInspectorExCollection.filter(
                                t => t.VisibleSolicitante && t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
                            );
                        } else {
                            this.TComentarioInspectorExCollection = this.solicitudEquipamientosEx.TComentarioInspectorExCollection.filter(
                                t => t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
                            );
                        }

                        this.inspeccionEx.TSolicitudEquipamientoExCollection = this.solicitudEquipamientosEx.TSolicitudEquipamientoExCollection;
                        this.matriculasInsp = this.solicitudEquipamientosEx.TSolicitudEquipamientoExCollection;

                        this.matriculasInsp.map((o, i) => {
                            const control = new UntypedFormControl(o.Inspeccion); // if first item set to true, else false
                            (this.form.controls.matriculasInsp as UntypedFormArray).push(control);
                        });

                        if (
                            this.solicitudEquipamientosEx.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION &&
                            this.certificadoOInsAdicionalRequired
                        ) {
                            this.addWarningMessage('Es necesario cumplimentar previamente los datos del apartado de Re-Exportación');
                            for (let control in this.form.controls) {
                                this.form.controls[control].disable();
                            }
                            this.habilitarGuardar = false;
                            this.habilitarEdicion = false;

                            return;
                        }
                    });
                }
            });
        }
    }

    checkEdit(rowData: TComentarioInspectorExViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }

    checkDelete(rowData: TComentarioInspectorExViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }

    onAddSeguimiento() {
        this.router.navigate(['/exportacion/solicitud/seguimientosEx', this.IdSolicitudEx, 'createSeguimiento', 'inspecciones']);
        //this.router.navigate([this.router.url, 'createSeguimiento']);
    }

    onEditSeguimiento(item: TComentarioInspectorExViewModel) {
        this.router.navigate(['/exportacion/solicitud/seguimientosEx', item.IdSolicitudEx, 'detalleseguimiento', item.Id]);
        //this.router.navigate([this.router.url, 'detalleseguimiento', item.Id]);
    }

    onDeleteSeguimiento(item: TComentarioInspectorExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.seguimientoExService.deleteSeguimientoEx(item.Id).subscribe(res => {
                    this.addSuccessMessage('Seguimiento eliminado correctamente');
                    //this.onSearchButton();
                    this.ngOnInit();
                });
            },
        });
    }

    verificarReasignacionPcf(isInspector: boolean) {
        this.habilitarReasignacionPcf = false;

        this.inspeccionesExService.aplicaDocumentacion(this.IdSolicitudEx).subscribe({
            next: aplicaDoc => {
                this.inspeccionesExService.tieneReasignacionManual(this.IdSolicitudEx).subscribe({
                    next: tieneReasignacion => {
                        // Habilitar el botón solo si aplica documentación, no tiene reasignación manual y es inspector
                        if (isInspector && aplicaDoc && !tieneReasignacion && this.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS) {
                            this.habilitarReasignacionPcf = true; // Habilitar el botón
                        } else {
                            this.habilitarReasignacionPcf = false; // Deshabilitar el botón
                        }
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    onReasignarPcf() {
        this.router.navigate(['/exportacion/solicitud/inspeccionesEx', this.IdSolicitudEx, 'reasignacionPcf']);
    }

    private DisableControlsConsulta() {
        //this.form.controls['InspectorDocumental'].disable();
        this.form.controls['Documental'].disable();
        this.form.controls['SeEfectuaIdentidadFisica'].disable();
        this.form.controls['Identidad'].disable();
        this.form.controls['Fisica'].disable();
        this.form.controls['Observaciones'].disable();
        this.form.controls['IdDecision'].disable();
        //DESINFECCION
        this.form.controls['Tratamiento'].disable();
        this.form.controls['ProductoQuimico'].disable();
        this.form.controls['Concentracion'].disable();
        this.form.controls['Duracion'].disable();
        this.form.controls['Temperatura'].disable();
        this.form.controls['FechaDesinfeccion'].disable();
        this.form.controls['InformacionAdicional'].disable();
    }

    guardRefreshPage(id: number) {
        //Fuerzo que lo haga siempre pq fallaba al refrescar cuando cambiaba de estado
        if (id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            InspectorDocumental: '',
            InspectorIdentidad: '',
            InspectorFisica: '',
            FechaDocumental: null,
            FechaIdentidad: null,
            FechaFisica: null,
            Documental: null,
            SeEfectuaIdentidadFisica: false,
            Identidad: null,
            Fisica: null,
            Observaciones: '',
            IdDecision: null,
            matriculasInsp: new UntypedFormArray([]),
            validPosicionamiento: '',
            Tratamiento: null,
            ProductoQuimico: null,
            Concentracion: null,
            Duracion: null,
            Temperatura: null,
            FechaDesinfeccion: null,
            InformacionAdicional: null,
        });
    }

    updateForm() {
        //se usa el patchValue pq las matriculas se leen fuera de este bloque
        this.form.patchValue({
            InspectorDocumental: this.inspeccionEx.IdUsuarioDocumentalDescripcion,
            InspectorIdentidad: this.inspeccionEx.IdUsuarioIdentidadDescripcion,
            InspectorFisica: this.inspeccionEx.IdUsuarioFisicaDescripcion,
            FechaDocumental: this.datepipe.transform(this.inspeccionEx.FechaDocumental, 'dd/MM/yyyy'),
            FechaIdentidad: this.datepipe.transform(this.inspeccionEx.FechaIdentidad, 'dd/MM/yyyy'),
            FechaFisica: this.datepipe.transform(this.inspeccionEx.FechaFisica, 'dd/MM/yyyy'),
            Documental: this.inspeccionEx.Documental,
            SeEfectuaIdentidadFisica: this.inspeccionEx.SeEfectuaIdentidadFisica,
            Identidad: this.inspeccionEx.Identidad,
            Fisica: this.inspeccionEx.Fisica,
            Observaciones: this.inspeccionEx.Observaciones,
            IdDecision:
                this.inspeccionEx.IdDecision == EnumIdsTwTcDecisionInspeccion.ACEPTAR
                    ? 'A'
                    : this.inspeccionEx.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR
                      ? 'R'
                      : null,
            validPosicionamiento: '',
            Tratamiento: this.inspeccionEx.TTratamientoDesinfeccionEx != null ? this.inspeccionEx.TTratamientoDesinfeccionEx.Tratamiento : null,
            ProductoQuimico: this.inspeccionEx.TTratamientoDesinfeccionEx != null ? this.inspeccionEx.TTratamientoDesinfeccionEx.ProductoQuimico : null,
            Concentracion: this.inspeccionEx.TTratamientoDesinfeccionEx != null ? this.inspeccionEx.TTratamientoDesinfeccionEx.Concentracion : null,
            Duracion: this.inspeccionEx.TTratamientoDesinfeccionEx != null ? this.inspeccionEx.TTratamientoDesinfeccionEx.Duracion : null,
            Temperatura: this.inspeccionEx.TTratamientoDesinfeccionEx != null ? this.inspeccionEx.TTratamientoDesinfeccionEx.Temperatura : null,
            FechaDesinfeccion:
                this.inspeccionEx.TTratamientoDesinfeccionEx != null && this.inspeccionEx.TTratamientoDesinfeccionEx.Fecha != null
                    ? new Date(this.inspeccionEx.TTratamientoDesinfeccionEx.Fecha)
                    : null,
            InformacionAdicional:
                this.inspeccionEx.TTratamientoDesinfeccionEx != null ? this.inspeccionEx.TTratamientoDesinfeccionEx.InformacionAdicional : null,
        });

        //Carga de los check labels
        this.labelDocumental = this.inspeccionEx.Documental ? this.labelApto : this.inspeccionEx.Documental == null ? '' : this.labelNoApto;
        this.labelIdentidad = this.inspeccionEx.Identidad ? this.labelApto : this.inspeccionEx.Identidad == null ? '' : this.labelNoApto;
        this.labelFisica = this.inspeccionEx.Fisica ? this.labelApto : this.inspeccionEx.Fisica == null ? '' : this.labelNoApto;

        if (this.habilitarEdicion) {
            this.form.controls['SeEfectuaIdentidadFisica'].enable();
            this.SelectedIdentidadFisicaNoClick();
        }

        this.Documental = this.inspeccionEx.Documental!;
        this.Identidad = this.inspeccionEx.Identidad!;
        this.Fisica = this.inspeccionEx.Fisica!;
        this.SeEfectuaIdentidadFisica = this.inspeccionEx.SeEfectuaIdentidadFisica;
    }

    guardarInspecciones() {
        this.confirmationService.confirm({
            message: '¿Está seguro de guardar la inspección de la solicitud?.',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onRevisionSolicitanteConfirm() {
        let mensajeRevision: string;
        if (this.inspeccionEx.Observaciones == '') {
            mensajeRevision = 'Va a devolver la solicitud al solicitante sin Observaciones guardadas, ¿está seguro?';
        } else {
            mensajeRevision = 'Va a devolver la solicitud al solicitante, ¿está seguro?';
        }

        this.confirmationService.confirm({
            message: mensajeRevision,
            accept: () => {
                let params = new HttpParams();

                params = params.append('idSolicitudEx', this.IdSolicitudEx.toString());
                params = params.append('idUsuario', this.loggedInUser!.Id.toString());

                this.inspeccionesExService.revisionSolicitante(params).subscribe({
                    next: () => {
                        this.addSuccessMessage('Solicitud devuelta correctamente');
                        this.firstInit = false;

                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onNuevoEquipamiento() {
        this.matriculaPrecintoPopupComponent.showDialog(this.IdSolicitudEx, null);
    }

    editEquipamiento(equipamiento: any) {
        this.matriculaPrecintoPopupComponent.showDialog(this.IdSolicitudEx, equipamiento);
    }

    deleteEquipamiento(equipamiento: any) {
        let index = this.matriculasInsp.indexOf(equipamiento);
        this.matriculasInsp.splice(index, 1);

        (this.form.controls.matriculasInsp as UntypedFormArray).removeAt(index);
    }

    getMatriculaControls() {
        return (<UntypedFormArray>this.form.controls.matriculasInsp).controls;
    }

    getFrControls() {
        return (<UntypedFormArray>this.form.controls.frInsp).controls;
    }

    onAcceptDialogMatriculaPrecinto(equipamiento: any) {
        //se añade el equipamiento a la collection si es un alta
        if (equipamiento.Id == null) {
            this.inspeccionEx.TSolicitudEquipamientoExCollection.push(equipamiento);

            this.matriculasInsp = this.inspeccionEx.TSolicitudEquipamientoExCollection;

            const control = new UntypedFormControl(false); // if first item set to true, else false
            (this.form.controls.matriculasInsp as UntypedFormArray).push(control);
        }
    }

    onSelectedDecision() {
        if (this.form.value.IdDecision == 'R') {
            this.addValidator('Observaciones', Validators.required);
            this.requerirObservaciones = true;
        } else {
            this.removeValidators('Observaciones');
            this.requerirObservaciones = false;
        }
    }

    onSelectedIdentidadFisica() {
        this.SeEfectuaIdentidadFisica = this.form.value.SeEfectuaIdentidadFisica;

        if (this.form.value.SeEfectuaIdentidadFisica) {
            this.form.controls['Identidad'].enable();
            this.form.controls['Fisica'].enable();
        } else {
            this.form.patchValue({
                Identidad: null,
                Fisica: null,
            });
            this.Identidad = null;
            this.Fisica = null;

            this.form.controls['Identidad'].disable();
            this.form.controls['Fisica'].disable();
            this.labelIdentidad = '';
            this.labelFisica = '';
            this.requerirObservaciones = false;
        }

        this.resetDecision();
        this.gestionarVisibilidadDecision();
    }

    //Metodo que se llama sin hacer click
    SelectedIdentidadFisicaNoClick() {
        this.SeEfectuaIdentidadFisica =
            this.form.value.SeEfectuaIdentidadFisica != undefined ? this.form.value.SeEfectuaIdentidadFisica : this.inspeccionEx.SeEfectuaIdentidadFisica;

        if (this.form.value.SeEfectuaIdentidadFisica) {
            this.form.controls['Identidad'].enable();
            this.form.controls['Fisica'].enable();
        } else {
            this.form.patchValue({
                Identidad: null,
                Fisica: null,
            });
            this.Identidad = null;
            this.Fisica = null;

            this.form.controls['Identidad'].disable();
            this.form.controls['Fisica'].disable();
            this.labelIdentidad = '';
            this.labelFisica = '';
        }
    }

    onChangeDocumental() {
        if (this.form.value.Documental == null) {
            this.labelDocumental = '';
            this.requerirObservaciones = false;
        } else if (this.form.value.Documental) {
            this.labelDocumental = this.labelApto;
            this.form.controls['SeEfectuaIdentidadFisica'].enable();
            this.requerirObservaciones = false;
        } else if (!this.form.value.Documental) {
            this.labelDocumental = this.labelNoApto;
            this.form.controls['SeEfectuaIdentidadFisica'].disable();
            this.requerirObservaciones = true;

            this.form.patchValue({
                SeEfectuaIdentidadFisica: false,
            });
            this.SelectedIdentidadFisicaNoClick();
        }

        this.Documental = this.form.value.Documental;

        this.resetDecision();
        this.gestionarVisibilidadDecision();
    }

    onChangeIdentidad() {
        if (this.form.value.Identidad == null) {
            this.labelIdentidad = '';
        } else if (this.form.value.Identidad) {
            this.labelIdentidad = this.labelApto;
        } else if (!this.form.value.Identidad) {
            this.labelIdentidad = this.labelNoApto;
        }

        this.requerirObservaciones = this.labelIdentidad === this.labelNoApto || this.labelFisica === this.labelNoApto;

        this.Identidad = this.form.value.Identidad;

        this.resetDecision();
        this.gestionarVisibilidadDecision();
    }

    onChangeFisica() {
        if (this.form.value.Fisica == null) {
            this.labelFisica = '';
        } else if (this.form.value.Fisica) {
            this.labelFisica = this.labelApto;
        } else if (!this.form.value.Fisica) {
            this.labelFisica = this.labelNoApto;
        }

        this.requerirObservaciones = this.labelIdentidad === this.labelNoApto || this.labelFisica === this.labelNoApto;

        this.Fisica = this.form.value.Fisica;

        this.resetDecision();
        this.gestionarVisibilidadDecision();
    }

    private gestionarVisibilidadDecision() {
        this.habilitarAceptarDecision = false;

        if (this.Documental) {
            if (
                !this.SeEfectuaIdentidadFisica ||
                (this.Identidad && this.Fisica == null) ||
                (this.Fisica && this.Identidad == null) ||
                (this.Identidad && this.Fisica)
            ) {
                this.habilitarAceptarDecision = true;
            }
        }

        //para Rechazar, mínimo tiene que haber una inspección en "No Apto"
        this.habilitarRechazarDecision = this.Documental == false || this.Identidad == false || this.Fisica == false;

        //al menos tiene que estar visible alguna de las posibles decisiones, si no, ocultamos el panel de decisión hasta que se cumpla alguna condición
        this.visibilityDecision = this.habilitarAceptarDecision || this.habilitarRechazarDecision;
    }

    private resetDecision() {
        this.form.patchValue({
            IdDecision: null,
        });
    }

    tieneTratamientoDesinfeccion() {
        let respuesta = false;
        if (
            (this.form.value.Tratamiento != '' && this.form.value.Tratamiento != null) ||
            (this.form.value.ProductoQuimico != '' && this.form.value.ProductoQuimico != null) ||
            (this.form.value.Concentracion != '' && this.form.value.Concentracion != null) ||
            (this.form.value.Duracion != '' && this.form.value.Duracion != null) ||
            (this.form.value.Temperatura != '' && this.form.value.Temperatura != null) ||
            this.form.value.FechaDesinfeccion != null ||
            (this.form.value.InformacionAdicional != '' && this.form.value.InformacionAdicional != null)
        ) {
            respuesta = true;
        }
        return respuesta;
    }

    onSubmit() {
        let selectedMatriculas: string[];

        if (this.form.controls.matriculasInsp.value.length > 0) {
            selectedMatriculas = this.form.controls.matriculasInsp.value
                .map((v: any, i: any) => (v ? this.matriculasInsp[i].Matricula : null))
                .filter((v: any) => v !== null);
            //Validamos que haya mercancia posicionada, si no es un Traslado y se va a efectuar la física
            if (selectedMatriculas.length == 0 && !this.EsAeropuerto && this.SeEfectuaIdentidadFisica) {
                this.addValidator('validPosicionamiento', Validators.required);
            } else {
                this.removeValidators('validPosicionamiento');
            }
        }

        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la inspección');
            return;
        }

        this.visibilitySpinner = true;

        let inspeccionEx = new TInspeccionExViewModel();

        inspeccionEx.Documental = this.Documental;
        inspeccionEx.SeEfectuaIdentidadFisica = this.SeEfectuaIdentidadFisica;
        inspeccionEx.Identidad = this.Identidad;
        inspeccionEx.Fisica = this.Fisica;
        inspeccionEx.IdUsuarioDocumental = this.IdInspector;
        inspeccionEx.IdUsuarioIdentidad = this.IdInspector;
        inspeccionEx.IdUsuarioFisica = this.IdInspector;
        inspeccionEx.Observaciones = this.form.value.Observaciones;
        inspeccionEx.IdDecision = this.form.value.IdDecision == 'A' ? 1 : this.form.value.IdDecision == 'R' ? 2 : null;

        if (this.tieneTratamientoDesinfeccion()) {
            inspeccionEx.TTratamientoDesinfeccionEx = new TTratamientoDesinfeccionExViewModel();

            inspeccionEx.TTratamientoDesinfeccionEx.Tratamiento = this.form.value.Tratamiento;
            inspeccionEx.TTratamientoDesinfeccionEx.ProductoQuimico = this.form.value.ProductoQuimico;
            inspeccionEx.TTratamientoDesinfeccionEx.Concentracion = this.form.value.Concentracion;
            inspeccionEx.TTratamientoDesinfeccionEx.Duracion = this.form.value.Duracion;
            inspeccionEx.TTratamientoDesinfeccionEx.Temperatura = this.form.value.Temperatura;
            inspeccionEx.TTratamientoDesinfeccionEx.Fecha = this.form.value.FechaDesinfeccion;
            inspeccionEx.TTratamientoDesinfeccionEx.InformacionAdicional = this.form.value.InformacionAdicional;
        }

        inspeccionEx.TSolicitudEquipamientoExCollection = this.inspeccionEx.TSolicitudEquipamientoExCollection;

        if (inspeccionEx.TSolicitudEquipamientoExCollection != null) {
            inspeccionEx.TSolicitudEquipamientoExCollection.forEach(y => {
                //1º Pongo toda la coleccion a false por defecto
                y.Inspeccion = false;
                if (selectedMatriculas.includes(y.Matricula)) {
                    y.Inspeccion = true;
                }
            });
        }
        //}

        if (this.inspeccionEx.FechaDocumental != null) {
            inspeccionEx.FechaDocumental = this.inspeccionEx.FechaDocumental;
        }

        inspeccionEx.IdSolicitudEx = this.IdSolicitudEx;

        if (this.editMode) {
            this.inspeccionesExService.editInspeccionEx(inspeccionEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Inspección guardada correctamente');
                    //this.onBack();
                    this.visibilitySpinner = false;
                    this.firstInit = false;

                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error.error.error.includes('enviar correo')) {
                        this.ngOnInit();
                    }
                },
            });
        } else {
            this.inspeccionesExService.createInspeccionEx(inspeccionEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Inspección guardada correctamente');
                    //this.onBack();
                    this.visibilitySpinner = false;
                    this.firstInit = false;

                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error.error.error.includes('enviar correo')) {
                        this.ngOnInit();
                    }
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.IdSolicitudEx]);
    }

    private get certificadoOInsAdicionalRequired(): boolean {
        return (
            this.isInspector &&
            (this.solicitudEquipamientosEx.TReexportacionEx === null ||
                (!this.solicitudEquipamientosEx.TReexportacionEx.CertFitoOriginal && !this.solicitudEquipamientosEx.TReexportacionEx.InspAdicional))
        );
    }

    get allowReasignacion(): boolean {
        return this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.REASIGNACION_MANUAL).Visible || false;
    }
}
